import { Component, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { Breakpoints, BreakpointState, BreakpointObserver } from '@angular/cdk/layout';
import { Vehicle } from 'src/app/Models/vehicle';
import { ApiService } from 'src/app/core/services/api.service';
import { HttpParams } from '@angular/common/http';
import { ItemStatusCount } from 'src/app/dtos/item-status-count';
import { ShipDetailEnum } from 'src/app/enums/ship-detail-enum';
import { OperativesDto } from 'src/app/dtos/operatives-dto';
import { DeliveredVsScheduled } from 'src/app/dtos/delivered-vs-scheduled-dto';
import { BaseChartDirective } from 'ng2-charts';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent {

  initDateStatus: Date = new Date();
  endDateStatus: Date = new Date();
  initDateStatusReco: Date = new Date();
  endDateStatusReco: Date = new Date();
  initDateDS: Date = new Date();
  endDateDS: Date = new Date();
  vehicles: Vehicle[] = [];
  selectedVehicleStatus: Vehicle;
  selectedVehicleStatusReco: Vehicle;
  selectedVehicleDS: Vehicle;

  operatives: OperativesDto[] = [];
  selectedOperativeDS: OperativesDto;


  public chartColors: any[] = [
    { 
      backgroundColor:["#f4ea3d","#f4ea3d","#f4ea3d","#f4ea3d","#f4ea3d","#f4ea3d", "#f4ea3d"] 
    },
    { 
      backgroundColor:["#22b573","#22b573","#22b573","#22b573","#22b573","#22b573", "#22b573"] 
    }];

    public chartColors2: any[] = [
      { 
        backgroundColor:["#ff3333","#ff3333","#ff3333","#ff3333","#ff3333","#ff3333", "#ff3333"] 
      }];

      @ViewChild('donut1') public chart: BaseChartDirective;

  public lineChartLabels:string[] = [];
  public lineChartData:any[] = [];
  public lineChartType:string = 'line';
  showDVSS: boolean = false;


public doughnutChartLabels:string[] = [];
public doughnutChartData:number[] = [];
public doughnutChartType:string = 'doughnut';
showStatusItem: boolean = false;

public doughnutChartLabelsReco:string[] = [];
public doughnutChartDataReco:number[] = [];
showStatusItemReco: boolean = false;

  public doubleBarChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };


  constructor(private apiService: ApiService) {
    this.initDateStatus.setMonth(this.initDateStatus.getMonth() - 1);
    this.initDateDS.setMonth(this.initDateDS.getMonth() - 1);
    this.initDateStatusReco.setMonth(this.initDateStatusReco.getMonth() - 1);
    this.getVehicles();
    this.getOperatives();
    this.getDeliveredVsScheduleds();
    this.getStatusItemsCount();
    this.getStatusItemsRecoCount();
   }

  
  // events
  public chartClicked(e:any):void {
    
  }
 
  public chartHovered(e:any):void {
    
  }
 


  getVehicles() {
    this.apiService.get('api/vehicle/findAll').subscribe((response: any) => {
      if (response.data) {
        this.vehicles = response.data;
        let first = new Vehicle();
        first.id = 0;
        first.registerNumber = 'GENERAL.LABELS.VEHICLES';
        this.vehicles.splice(0, 0, first);
        this.selectedVehicleStatus = this.vehicles[0];
        this.selectedVehicleDS = this.vehicles[0];
        this.selectedVehicleStatusReco = this.vehicles[0];
      }
    });
  }

  getStatusItemsRecoCount(){
    let params: HttpParams = new HttpParams();
    params = params.append('initDate', this.initDateStatusReco.toISOString());
    params = params.append('endDate', this.endDateStatusReco.toISOString());
    if(this.selectedVehicleStatusReco && this.selectedVehicleStatusReco.id != 0)
       params = params.append('vehicle', this.selectedVehicleStatusReco.id.toString());
    this.apiService.get('api/itemShipDetail/getItemsStatusRecoCount', params).subscribe(response => {
      if(response.data){
          let result: ItemStatusCount[] = response.data;
          this.showStatusItemReco = false;
          this.doughnutChartDataReco.length = 0;
          this.doughnutChartLabelsReco.length = 0;
          result.forEach(element => {
            this.doughnutChartDataReco.push(element.sumItems);
            if(element.statusItem == ShipDetailEnum.REJECTED_CLIENT){
              this.doughnutChartLabelsReco.push('Reagendados');
            }
            if(element.statusItem == ShipDetailEnum.LOADED){
              this.doughnutChartLabelsReco.push('Recolectados');
            }
          });
          if(this.doughnutChartLabelsReco.length == 0){
            this.doughnutChartLabelsReco.push('Recolectados');
            this.doughnutChartLabelsReco.push('Reagendados');
            this.doughnutChartDataReco.push(0);
            this.doughnutChartDataReco.push(0);
          }
          setTimeout(()=>{this.showStatusItemReco = true}, 0)
      }
    });
  }

  getStatusItemsCount(){
    let params: HttpParams = new HttpParams();
    params = params.append('initDate', this.initDateStatus.toISOString());
    params = params.append('endDate', this.endDateStatus.toISOString());
    if(this.selectedVehicleStatus && this.selectedVehicleStatus.id != 0)
       params = params.append('vehicle', this.selectedVehicleStatus.id.toString());
    this.apiService.get('api/itemShipDetail/getItemsCountStatus', params).subscribe(response => {
      if(response.data){
          let result: ItemStatusCount[] = response.data;
          this.showStatusItem = false;
          this.doughnutChartData.length = 0;
          this.doughnutChartLabels.length = 0;
          result.forEach(element => {
            this.doughnutChartData.push(element.sumItems);
            if(element.statusItem == ShipDetailEnum.DELIVERED){
              this.doughnutChartLabels.push('Entregados');
            }
            if(element.statusItem == ShipDetailEnum.REJECTED){
              this.doughnutChartLabels.push('Rechazados');
            }
            if(element.statusItem == ShipDetailEnum.REJECTED_CLIENT){
              this.doughnutChartLabels.push('Reagendados');
            }
          });
          if(this.doughnutChartLabels.length == 0){
            //this.doughnutChartLabels.push('No hay datos');
            this.doughnutChartLabels.push('Entregados');
            this.doughnutChartLabels.push('Rechazados');
            this.doughnutChartLabels.push('Reagendados');
            this.doughnutChartData.push(0);
            this.doughnutChartData.push(0);
            this.doughnutChartData.push(0);
          }
          setTimeout(()=>{this.showStatusItem = true}, 0)
          
      }
    });
  }

  getDeliveredVsScheduleds(){
    let params: HttpParams = new HttpParams();
    params = params.append('initDate', this.initDateDS.toISOString());
    params = params.append('endDate', this.endDateDS.toISOString());
    if(this.selectedOperativeDS && this.selectedVehicleDS.id != 0)
       params = params.append('vehicle', this.selectedVehicleDS.id.toString());
    if(this.selectedOperativeDS && this.selectedOperativeDS.id != 0)
       params = params.append('operador', this.selectedOperativeDS.username);
    this.apiService.get('api/itemShipDetail/getDeliveredVsScheduleds', params).subscribe(response => {
        if(response.data){
          let result: DeliveredVsScheduled[] = response.data;
          let deli: number[] = [];
          let sched: number[] = [];
          this.showDVSS = false;
          this.lineChartLabels.length = 0;
          this.lineChartData = [];
          result.forEach(element => {
            let temDate = new Date(element.date);
            this.lineChartLabels.push(temDate.getUTCDate() + '/' + (temDate.getUTCMonth() + 1));
            deli.push(element.deliveredCount);
            sched.push(element.scheduledCount);
          });
          this.lineChartData.push({data: deli, label: 'Cargados'});
          this.lineChartData.push({data: sched, label: 'Programados'});
          this.showDVSS = true;
        }
    });
  }

  getOperatives(){
    
    this.apiService.get('api/user/getOperatives').subscribe(response => {
      if(response.data){
        this.operatives = response.data;
        let first = new OperativesDto();
        first.id = 0;
        first.username = 'GENERAL.LABELS.OPERATIVES';
        this.operatives.splice(0, 0, first);
        this.selectedOperativeDS = this.operatives[0];
      }
    });
  }

}
